import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';

export default class ConfirmModal extends React.Component {

    render() {
        const {
            show,
            onHide,
            onAccept,
            title,
            bodyTitle,
            bodyText,
            textButtonAccept,
            textButtonCancel,
        } = this.props;

        const buttonCancelContent = textButtonCancel || I18nUtils.tr('TR_CANCELAR');
        const buttonAcceptContent = textButtonAccept || I18nUtils.tr('TR_ACEPTAR');

        return (
            <Modal
                show={show}
                aria-labelledby="contained-modal-title-sm"
                onHide={onHide}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-sm">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>{bodyTitle}</h4>
                    <p><small>{bodyText}</small></p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        bsStyle="danger"
                        onClick={onHide}
                        children={buttonCancelContent}
                    />
                    <Button
                        bsStyle="success"
                        onClick={onAccept}
                        children={buttonAcceptContent}
                    />
                </Modal.Footer>
            </Modal>
        );
    }
}

ConfirmModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    bodyTitle: PropTypes.string,
    bodyText: PropTypes.any.isRequired,
    textButtonCancel: PropTypes.string,
    textButtonAccept: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/confirm-modal/ConfirmModal.jsx